module.exports = __webpack_public_path__ + "img/ru.562474ef.svg";